import { render } from "./CustomerInfoSection.vue?vue&type=template&id=0a070ad6&scoped=true"
import script from "./CustomerInfoSection.vue?vue&type=script&lang=js"
export * from "./CustomerInfoSection.vue?vue&type=script&lang=js"

import "./CustomerInfoSection.vue?vue&type=style&index=0&id=0a070ad6&scoped=true&lang=css"

import exportComponent from "../../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a070ad6"]])

export default __exports__